<template>
  <fieldset class="search-suggest-uv">
    <input
      type="search"
      v-model="valor"
      @input="
        (event) => {
          $emit('input', event.target.value);
        }
      "
      @change="emitChange()"
      :placeholder="placeholderText"
      aria-haspopup="true"
      aria-expanded="false"
      @focus="showSuggest = true"
      @blur="showSuggest = false"
      accesskey="s"
    />
    <button v-if="false" type="button" form="search-suggest-uv">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        viewBox="0 0 24 24"
      >
        <path
          d="M15.85 16.56a9.5 9.5 0 11.7-.7l7.45 7.43-.7.71-7.45-7.44zM9.5 1a8.5 8.5 0 110 17 8.5 8.5 0 010-17z"
        />
      </svg>
      Buscar
    </button>

    <ul
      v-bind:class="[showSuggest == false ? 'hidden' : '']"
      class="listSuggets-uv"
    >
      <p class="headersuggest">{{ headerSuggestText }}</p>
      <template v-for="(suggest, index) in suggestOptions">
        <li :key="index" @click="selectSuggest(suggest.value)">
          <a href="javascript:void(0);">
            <mark v-if="suggest.mark">{{ suggest.text }}</mark>
            <b v-if="!suggest.mark">{{ suggest.text }}</b>
          </a>
        </li>
      </template>
    </ul>
  </fieldset>
</template>

<style scoped>
.search-suggest-uv {
  position: relative;
  display: inline-block;
  width: 100%;
  /*max-width: 250px;*/
  /*-webkit-perspective: 600px;
  perspective: 600px;*/
  border: 0;
  margin: 0;
  padding: 0;
  font-size: 14px;
}
.listSuggets-uv {
  -webkit-box-shadow: 0px 14px 19px -6px rgba(0, 0, 0, 0.59);
  -moz-box-shadow: 0px 14px 19px -6px rgba(0, 0, 0, 0.59);
  box-shadow: 0px 14px 19px -6px rgba(0, 0, 0, 0.59);
}
.headersuggest {
  margin: 0px 10px !important;
  color: #989898;
  font-size: 12px;
}

.search-suggest-uv *::-moz-selection {
  color: #8e37d7;
  background: rgba(44, 216, 213, 0.2);
}
.search-suggest-uv *::selection {
  color: #8e37d7;
  background: rgba(44, 216, 213, 0.2);
}
.search-suggest-uv input {
  padding: 0.5em 3em 0.5em 1em;
  margin: 0;
  border: 0;
  border-radius: 2px;
  font: inherit;
  font-size: 1em;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 1px;
  caret-color: currentColor;
  color: rgba(0, 0, 0, 0.87);
  outline: none;
  cursor: default;
  width: 100%;
  height: 3em;
  box-shadow: 0.3em 0.5em 1em 0 rgba(0, 0, 0, 0.1);
}
.search-suggest-uv input::-webkit-input-placeholder {
  font: inherit;
  opacity: 0.5;
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
  color: rgba(0, 0, 0, 0.87);
}
.search-suggest-uv input::-moz-placeholder {
  font: inherit;
  opacity: 0.5;
  -moz-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
  color: rgba(0, 0, 0, 0.87);
}
.search-suggest-uv input:-ms-input-placeholder {
  font: inherit;
  opacity: 0.5;
  -ms-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
  color: rgba(0, 0, 0, 0.87);
}
.search-suggest-uv input::-ms-input-placeholder {
  font: inherit;
  opacity: 0.5;
  -ms-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
  color: rgba(0, 0, 0, 0.87);
}
.search-suggest-uv input::placeholder {
  font: inherit;
  opacity: 0.5;
  -webkit-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
  color: rgba(0, 0, 0, 0.87);
}
.search-suggest-uv input::-webkit-search-cancel-button {
  color: #8e37d7;
  cursor: pointer;
  opacity: 0.3;
}
.search-suggest-uv input::-webkit-search-cancel-button:hover {
  opacity: 1;
}
.search-suggest-uv input::-ms-clear {
  color: #8e37d7;
  cursor: pointer;
  opacity: 0.3;
}
.search-suggest-uv input::-ms-clear:hover {
  opacity: 1;
}
.search-suggest-uv button {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  width: 3em;
  height: 3em;
  color: #8e37d7;
  font-size: 1em;
  line-height: 1;
  text-indent: -9999em;
  border: 0;
  background: rgba(255, 255, 255, 0);
  cursor: pointer;
}
.search-suggest-uv button:hover,
.search-suggest-uv button:focus {
  color: #2cd8d5;
  outline: none;
}
.search-suggest-uv button svg {
  position: absolute;
  left: 15%;
  top: 15%;
  width: 70%;
  height: 70%;
  fill: currentColor;
  -webkit-transform: scale(0.8);
  transform: scale(0.8);
}
.search-suggest-uv ul {
  position: absolute;
  overflow: hidden;
  top: calc(3em - 2px);
  width: 100%;
  padding: 2px 0 0 0;
  margin: 0;
  background-color: #fff;
  text-align: left;
  list-style: none;
  border: 0;
  border-radius: 0 0 2px 2px;
  opacity: 1;
  -webkit-transform-origin: top;
  transform-origin: top;
  -webkit-transform: rotateX(0deg);
  transform: rotateX(0deg);
  -webkit-transition: opacity 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.3s,
    -webkit-transform 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.2s;
  transition: opacity 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.3s,
    -webkit-transform 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.2s;
  transition: transform 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.2s,
    opacity 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.3s;
  transition: transform 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.2s,
    opacity 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.3s,
    -webkit-transform 0.6s cubic-bezier(0.68, -0.55, 0.39, 1.3) -0.2s;
}
.search-suggest-uv ul.hidden {
  opacity: 0;
  -webkit-transform: rotateX(-90deg);
  transform: rotateX(-90deg);
  /*pointer-events: none;*/ /*No ejecuta eventos al dar click*/
  -webkit-transition: opacity 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09) 0.1s,
    -webkit-transform 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09);
  transition: opacity 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09) 0.1s,
    -webkit-transform 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09);
  transition: transform 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09),
    opacity 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09) 0.1s;
  transition: transform 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09),
    opacity 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09) 0.1s,
    -webkit-transform 0.6s cubic-bezier(0.71, -0.22, 0.33, 1.09);
}
.search-suggest-uv ul li {
  margin: 0;
  padding: 0;
  cursor: pointer;
}
.search-suggest-uv ul li a {
  text-decoration: none;
  display: block;
  padding: 0.7em 1em;
  color: #666;
  font-size: 1em;
  line-height: 1.3;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
}
.search-suggest-uv ul li a:hover,
.search-suggest-uv ul li a:focus {
  color: #474747;
  background: rgba(102, 102, 102, 0.1);
}
.search-suggest-uv ul li a:focus,
.search-suggest-uv ul li a:active {
  color: white;
  background: #8e37d7;
  outline: 0;
}
.search-suggest-uv ul li a:focus mark,
.search-suggest-uv ul li a:active mark {
  font-weight: normal;
  color: currentColor;
  background: none;
}
.search-suggest-uv ul li mark {
  font-weight: bold;
  overflow-wrap: break-word;
  color: #6435c9;
  background: rgb(34 36 38 / 0%);
}
.search-suggest-uv ul li:hover {
  color: #8e37d7;
}
</style>


<script>
export default {
  name: "suggestPriceInput",
  components: {},
  props: [
    "value",
    "data",
    "placeholderText",
    "headerSuggestText",
    "suggestOptions",
  ],
  data() {
    return {
      valor: "",
      placeholderTextDetail: "",
      showSuggest: false,
    };
  },
  methods: {
    selectSuggest(val) {
      this.valor = val;
      this.$emit("input", this.valor);
    },
    updateModel() {
      this.$emit("input", this.$refs.customSelect.value);
    },
    emitChange() {
      this.$emit("onChange");
    },
  },
  computed: {},
  watch: {
    value: function (newValue) {
      this.valor = newValue;
    },
    placeholderText: (newValue) => {
      this.placeholderTextDetail = newValue;
    },
    headerSuggestText: (n) => {
      this.$pgsHelper.log(n);
    },
  },
  beforeMount: function () {
    this.valor = this.value;
  },
  mounted() {},
};
</script>